import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

// eslint-disable-next-line import/no-default-export,react/display-name
export default (props: IconProps) => (
  <IconBox viewBox="0 10 64 44" {...props}>
    <path d="M0 20.5L9.5 11L32 33.5L54.5 11L64 20.5L32 52.5L0 20.5Z" />
  </IconBox>
);
